export const hex2Rgba = ({ hex, alpha = 1 } = {}) => {
  // 3-digit shorthand (e.g. "#f00") expands to the 6-digit form before parsing.
  const expandedHex = hex?.match(/^#[a-fA-F0-9]{3}$/i)
    ? `#${hex
        .slice(1)
        .split("")
        .map((c) => c + c)
        .join("")}`
    : hex;

  if (!expandedHex || !expandedHex.match(/^#[a-fA-F0-9]{6}$/i)) {
    // A colour a company stored that we cannot parse (e.g. a named colour like "red") would
    // otherwise render a plain white card with no signal that the data is wrong.
    console.warn(`hex2Rgba: unable to parse colour "${hex}", falling back to white`);
    return {
      r: 255,
      g: 255,
      b: 255,
      alpha: 1,
    };
  }
  const [r, g, b] = expandedHex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return {
    r,
    g,
    b,
    alpha,
  };
};

export const isColorLight = ({ r, g, b, alpha }) => {
  const brightness = r * 0.299 + g * 0.587 + b * 0.114 + (1 - alpha) * 255;
  return brightness > 186;
};

export const isColorDark = ({ r, g, b, alpha }) => {
  const brightness = r * 0.299 + g * 0.587 + b * 0.114 + (1 - alpha) * 255;

  return brightness < 186;
};

export const getTextColor = ({ hex = "" }) => {
  if (!hex) {
    return "#000000";
  }

  if (hex === "transparent") {
    return "#000000";
  }

  return isColorLight(hex2Rgba({ hex })) ? "#000000" : "#ffffff";
};
